//
// Module for the Milestone Review & Approval Index view
//
rs.module("fund/account/milestonereviewandapproval/index",

    ["common/select-helper", "controls/components/event-banner"],

    function (selectHelper, eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, sendCorrespondenceColumnID, preferredPrinter, selectionLimit) {

            var form = $.js(jsSelectors.milestoneReviewForm);

            var reviewActionRadioButtons = form.js(jsSelectors.reviewActionRadioButtons);

            var correspondenceFields = form.js(jsSelectors.correspondenceFields); 

            var skipCorrespondenceDisabledHiddenInput = correspondenceFields.js(jsSelectors.skipReviewHiddenInput);
            var skipCorrespondenceCheckBox = correspondenceFields.js(jsSelectors.skipReviewCheckBox);

            var printerSelect = correspondenceFields.js(jsSelectors.printerSelect);
            var printerSelectHelper = selectHelper.getHelper(printerSelect);

            var submitButton = form.js(jsSelectors.submitButton); 

            // On load, if a row is selected - scroll to ensure it is visible.
            if (lrsGridApi.agGridApi.getSelectedNodes().length != 0) {
                var firstSelectedRowIndex = lrsGridApi.agGridApi.getSelectedNodes()[0].rowIndex;
                lrsGridApi.agGridApi.ensureIndexVisible(firstSelectedRowIndex, 'middle');
            }

            reviewActionRadioButtons.find('input').click(function () {
                checkCorrespondenceFields(lrsGridApi.selectedRows);
            });

            lrsGridApi.selectionChanged(function (values, rows) {

                // Enforce ValueCountLimit on grid deletion. Since we can't send more than the supplied selection limit, disable submit button above that number.
                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged) {

                    // If greater than the supplied selection limit, disable submit button and add event message.
                    if (lrsGridApi.selectedValues.length >= selectionLimit) {
                        eventBanner.addErrorMessages("Up to " + $.format.number(selectionLimit, "#,##0") + " records may be selected to process at one time.");
                        submitButton.setDisabled();
                    }
                    else {
                        eventBanner.removeErrorMessages();
                        submitButton.setDisabled(false);
                    }
                }

                _executeSelectionChanged = true;

                checkCorrespondenceFields(rows);
            });

            // Only enable the printer if the Skip option is checked
            skipCorrespondenceCheckBox.change(function () {
                if (this.checked) {
                    if (preferredPrinter && preferredPrinter != '') {
                        printerSelectHelper.setValue(preferredPrinter);
                    }
                } else {
                    printerSelect.clearErrors();
                    printerSelectHelper.selectIndex(0);
                }

                printerSelectHelper.setDisabled(!this.checked);
            });

            // Determine how the correspondence fields should be
            // enabled/disabled and toggle appropriately
            function checkCorrespondenceFields(selectedRows) {
                var toggle = false;

                if (reviewActionRadioButtons.find('input:checked').val() == "Approve") {

                    correspondenceFields.show();

                    for (var i = 0; i < selectedRows.length; i++) {
                        toggle = selectedRows[i][sendCorrespondenceColumnID];

                        if (toggle) {
                            break;
                        }
                    }
                } else {
                    correspondenceFields.hide();
                }

                toggleCorrespondenceFields(toggle);
            }

            // Enable/Disable the correspondence fields
            function toggleCorrespondenceFields(enable) {
                if (!enable) {
                    skipCorrespondenceCheckBox.prop('checked', false);

                    printerSelect.clearErrors();
                    printerSelectHelper.selectIndex(0);

                    printerSelectHelper.setDisabled(true);
                }

                skipCorrespondenceCheckBox.prop('disabled', !enable);

                skipCorrespondenceDisabledHiddenInput.val(!enable);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);